import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';
import { FormBuilderThemes } from 'src/app/core/api/models';
import { ThemeColorType } from 'src/app/core/types/theme-color-type.type';

@Directive({
  selector: '[formThemeColor]',
})
export class FormThemeColorDirective {
  @Input() formThemeColor: FormBuilderThemes;
  @Input() type: ThemeColorType;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className += this.getCssClassList();
  }

  getCssClassList(): string {
    let className = ' ';

    switch (this.formThemeColor) {
      case FormBuilderThemes.Blue:
        className += this.type + '-blue';
        break;
      case FormBuilderThemes.Gray:
        className += this.type + '-slate';
        break;
      case FormBuilderThemes.Orange:
        className += this.type + '-orange';
        break;
      case FormBuilderThemes.Pink:
        className += this.type + '-pink';
        break;
      case FormBuilderThemes.Purple:
        className += this.type + '-info';
        break;
      case FormBuilderThemes.Red:
        className += this.type + '-danger';
        break;
      case FormBuilderThemes.Yellow:
        className += this.type + '-yellow';
        break;
      case FormBuilderThemes.Default:
        className += this.type + '-primary';
        break;
      default:
        className += this.type + '-primary';
        break;
    }
    return className;
  }
}
